// extracted by mini-css-extract-plugin
export default {"errorContainer":"ErrorPage_errorContainer__F3bV1","errorCode":"ErrorPage_errorCode__FxNOW","errorMessage":"ErrorPage_errorMessage__0+FdV"};